module.exports = __webpack_public_path__ + "6fe51374ff8a8ff7877b373a5ec4740f.pdf";